const STRINGS = {
  header: {
    support: 'Contact Maya for support',
    shop: 'Market',
    account: 'Account'
  },
  footer: {
    logout: 'Logout',
    change_language: 'Change language',
  },
  content: {
    loading: 'Loading'
  },
  shop: {
    transaction_type: 'Transaction type',
    product: 'Products',
    details: 'Details',
    review: 'Shopping Cart',
    loading: 'Loading'
  },
  account: {
    transactions: 'Transactions',
    reports: 'Reports',
    manage_employees: 'Manage Employees'
  },
  reports: {
    history: 'History',
    generate_report: 'Generate report',
    generate_quick_report: 'Quick detailed report',
    report_type: 'Report type',
    short_report: 'Short report',
    report_summary: 'Report summary',
    detailed_report: 'Detailed report',
    daily_report: 'Today',
    weekly_report: 'This week',
    monthly_report: 'This month',
    custom_dates_report: 'Custom dates report',
    print_report: 'Print report',
    created_date: 'Created date',
    type: 'Type',
    from: 'From',
    to: 'To',
    report_dates: 'Report date range',
    no_reports: 'No reports for this period',
    manual_reports: 'Manual',
    reports_table_title: 'Previously generated report history',
    automatic_reports: 'Automatic',
    settings_reports: 'Settings',
    enable_automatic_report: 'Enable automatic daily report',
    add_email: 'Enter email address',
    submit: 'Submit',
    select_day_of_week: 'Select days of week when you want to receive reports',
    add_emails: 'Add email addresses if you want to receive copy of report on email',
    week_day_0: 'Sunday',
    week_day_1: 'Monday',
    week_day_2: 'Tuesday',
    week_day_3: 'Wednesday',
    week_day_4: 'Thursday',
    week_day_5: 'Friday',
    week_day_6: 'Saturday'
  },
  reports_settings: {
    device: 'Device',
    assigned_employee: 'Assigned employee',
    manual_enabled: 'Manual report enabled',
    automatic_enabled: 'Automatic report enabled',
    no_devices: 'No devices',
    select_all: 'Select all'
  },
  clerks_management: {
    too_short: 'Too Short',
    too_long: 'Too Long',
    required: 'Field Required',
    invalid_email: 'Invalid email',
    server_validation_error: 'Server Validation Error',
    first_name: 'First name',
    last_name: 'Last name',
    employee_name: 'Employee name',
    phone: 'Phone number',
    email: 'Email',
    old_password: 'Old Password',
    new_password: 'New Password',
    confirm_new_password: 'Confirm New Password',
    password: 'Password',
    confirm_password: 'Confirm Password',
    create: 'Create',
    create_clerk: 'Create Employee',
    create_device: 'Create Device',
    password_short: 'Password has to be longer than 8 characters!',
    password_not_the_same: 'Passwords are not the same!',
    dont_match_phone: 'Fill Correctly',
    device: 'Device',
    attached_user: 'Attached Employee',
    enabled: 'Enabled',
    device_name: 'Device Name',
    device_without_user: 'Device without user',
    devices_not_found: 'Devices not found',
    employees_not_found: 'Employees not found',
    select_employee: 'Select Employee',
    edit: 'Edit',
    edit_employee: 'Edit employee info',
    device_update: 'Update Device',
    save: 'Save',
    own_device: 'This is your current device',
    only_active_devices: 'Show only active devices',
    devices: 'Devices',
    employees: 'Employees',
    change_password: 'Change password',
    submit: 'Submit',
    unexpected_error: 'Unexpected error',
    password_changed: 'Password has been changed',
    user_edit_success: 'Employee info has been updated',
    assign_on_me: 'Assigned on me',
    store_owner_device: 'The device belongs to another store owner',
    my_user: 'My user'
  },
  transactions: {
    transaction_not_found: 'Transactions not found',
    customer: 'Customer',
    received: 'Received',
    total_amount: 'Total amount',
    total_price: 'Total price',
    total_fee: 'Total fee',
    created_date: 'Created date',
    price: 'Price',
    fee: 'Fee',
    total: 'Total',
    cancel_modal_header: 'Cancel transaction',
    cancelled: 'Canceled',
    cancel_modal_text: 'Do you want to cancel transaction?',
    print_receipt: 'Print receipt'
  },
  login: {
    phone_number: 'Phone number',
    password: 'Password',
    login: 'Login',
    submit: 'Submit',
    back_to_login: 'Back',
    select_device: 'Select device',
    user_not_found_title: 'Clerk not found',
    user_not_found_message: 'Please contact with Maya support to sign up',
    access_denied_title: 'Access Denied',
    access_denied_message: 'You have not access to Maya OTC',
    device_not_found_title: 'Device not found',
    device_not_found_message: 'Please contact with Maya support',
    invalid_grant_title: 'Credential error',
    invalid_grant_message: 'Incorrect phone number or password',
    sso_error_title: 'Server error',
    sso_error_message: 'Please contact with Maya support',
    phone_number_invalid_title: 'Validation error',
    phone_number_invalid_message: 'Invalid phone number',
    password_invalid_title: 'Validation error',
    password_invalid_message: 'Password not entered',
    unexpected_error_title: 'Unexpected error',
    unexpected_error_message: 'Please contact with Maya support',
    add_new_clerk: 'Add new clerk',
    select_clerk: 'Select clerk from list'
  },
  categories: {
    pay_any_bill: 'Pay any Bill',
    pin_products: 'PIN Products',
    phone_reload: 'Phone Reload',
    international_topup: 'International Topup',
    card_reload: 'Card Reload',
    check_cashing: 'Check Cashing',
  },
  products: {
    no_products: 'Products not found',
    no_favorites: 'No favorites products',
    favorites: 'Favorites',
    search: 'Type to search',
    reset: 'Reset'
  },
  billers: {
    favorites: 'Favorite billers',
    no_favorites: 'No favorites biller',
    biller_search: 'Biller Search',
    no_results: 'No results',
    po_box: 'P.O.Box',
    zip: 'ZIP Code',
    biller_name: 'Biller name',
    biller_name_placeholder: 'Type biller name',
    or: 'OR',
    search: 'Search',
    results: 'Search results'
  },
  app_not_found: {
    not_found: 'Application not found',
    support: 'Contact with Maya for support',
    back: 'Exit'
  },
  pay_any_bill: {
    processing_type: 'Select processing type',
    priority: 'Priority',
    standard: 'Standard',
    account: 'Account #',
    confirm_account: 'Confirm Account #',
    bill_image: 'Bill image',
    account_again: 'Account again #',
    submit: 'Submit',
    account_number_not_equal_confirm_account: 'Account number should be equal with confirm account number',
    account_number_not_valid_header: 'Account number not valid',
    account_number_not_valid_content: 'Please check account number and try again',
    bill_image_processing_error_header: 'Image was not processed',
    bill_image_processing_error_content: 'Please check image quality and re-scan the image',
    unexpected_error: 'Unexpected error',
    select_account: 'Select customer\'s previous account #',
    back: 'Back',
    manual_entering: 'Manual entering',
    get_account_number: 'Get account number'
  },
  amounts: {
    phone_number: 'Customer phone number',
    phone_number_confirm: 'Confirm customer phone number',
    phone_number_not_valid_header: 'Phone number not valid',
    phone_number_not_valid_content: 'Please check customer phone number and try again',
    limit: 'amount limit',
    confirm: 'Confirm',
    change_customer: 'Change customer',
    enter_amount: 'Amount paid',
    amount_paid: 'Amount paid',
    fee: 'Fee',
    total_amount: 'Total amount',
    discount_amount: 'Discount amount'
  },
  app_navigation: {
    back: 'Back',
    next: 'Next',
    confirm: 'Confirm',
    submit: 'Submit transaction',
    support_message: 'Contact with Maya for support'
  },
  shopping_cart: {
    amount_paid: 'Amount paid',
    fee: 'Fee',
    total_amount: 'Total amount',
    account: 'Account',
    card_number: 'Card number',
    change: 'Change',
    empty_cart: 'Shopping cart is empty',
    customer: 'Customer',
    product_name: 'Product name',
    details: 'Details',
    created_date: 'Created date',
    amount: 'Amount',
    select_all: 'Select all products',
    delete_payment: 'Delete payment',
    delete_payment_details: 'Are you sure you want to delete this payment?',
    yes: 'Yes',
    no: 'No',
    pay_for_products: 'Pay for products',
    print_receipt: 'Print receipt',
    print_general_receipt: 'Print a general receipt',
    add_another_transaction: 'Add another transaction',
    add_transaction: 'Add transaction',
    enter_amount_received: 'Enter amount received'
  },
  timeout_overlay: {
    title: 'Need more time?',
    description: 'You will be log out automatically after',
    yes: 'Yes, I need more time',
    no: 'No, exit to login'
  },
  error_overlay: {
    auth_token_error: 'You open session from another browser. Current session was expired',
    logout: 'You will be log out automatically after 5 sec',
    unexpected_error: 'Unexpected error',
    access_denied: 'Your access token was expired',
    device_not_found: 'Device not found',
    user_not_found: 'User not found'
  },
  phonereload: {
    enter_amount: 'Enter amount',
    select_amount: 'Select amount...',
    invalid_number: 'Invalid phone number',
    invalid_operator: 'Invalid operator',
    invalid_metropcs_number: 'Invalid MetroPCS number',
    invalid_boostmobile_number: 'Invalid BoostMobile number'
  },
  international_phonereload: {
    enter_amount: 'Enter amount',
    select_amount: 'Select amount...',
    phone_number: 'Phone number',
    recipient_phone_number: 'Recipient phone number',
    invalid_number: 'Invalid phone number',
    invalid_operator: 'Invalid operator',
    invalid_metropcs_number: 'Invalid MetroPCS number',
    invalid_boostmobile_number: 'Invalid BoostMobile number',
    invalid_recipient_number: 'Invalid recipient number'
  },
  phonereload_ez_bill: {
    pin: 'PIN',
    enter_pin: 'Enter PIN',
    select_amount: 'Select amount...',
    enter_amount: 'Enter amount',
    phone_number: 'Phone number',
    recipient_phone_number: 'Recipient phone number',
    invalid_recipient_number: 'Invalid recipient number'
  },
  scanner: {
    scanner_not_found: 'Scanner not found',
    scanner_download_title: 'Install Maya OTC App and start scanning now!*',
    scanner_download_content: '*only if you have scanner device',
    scanner_download_button: 'Download Maya OTC App'
  },
  camera: {
    capture_photo: 'Capture photo',
    close_camera: 'Close camera',
    loading: 'Loading',
    user_media_error: 'No access to camera'
  },
  modal: {
    header: 'Are you sure?',
    yes: 'Yes',
    no: 'No'
  },
  cash_reload: {
    warning: '*You should have a card reader device for using that product',
    cardholder_name: 'Cardholder name',
    account: 'Account',
    balance: 'Balance',
    check_balance: 'Check balance'
  },
  check_cashing: {
    customer_photo: 'Customer photo',
    first_name: 'First name',
    middle_name: 'Middle name',
    last_name: 'Last name',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    unknown: 'Unknown',
    reset: 'Reset',
    email: 'Email',
    ssn: 'SSN',
    cell_phone: 'Cell phone',
    home_phone: 'Home phone',
    search_customer: 'Customer search',
    search_placeholder: 'Type to search',
    create_new_customer: 'Create new customer',
    date_of_birth: 'Date of birth',
    customer_status: 'Customer status',
    status_good: 'Good',
    status_neutral: 'Neutral',
    status_bad: 'Bad',
    status_high_risk: 'High-risk',
    address: 'Address',
    address1: 'Address 1',
    address2: 'Address 2',
    address_city: 'City',
    address_state: 'State',
    address_zip: 'Zip',
    address_search: 'Address search',
    id_details: 'Customer ID details',
    id_type: 'ID Type',
    id_number: 'ID Number',
    id_issuer: 'Issuer',
    id_expiration_date: 'Expiration date',
    id_front_image: 'ID front image',
    id_back_image: 'ID back image',
    capture_photo: 'Capture a photo',
    cancel: 'Cancel',
    create_customer: 'Create new customer',
    change_customer: 'Change customer',
    search: 'Search',
    passport: 'Passport',
    id_card: 'ID Card',
    reset_scanning: 'Reset scanning',
    scan_check: 'Scan a check',
    aba_number: 'ABA number',
    account_number: 'Account number',
    check_number: 'Check number',
    check_date: 'Check date',
    scan_image: 'Please, scan a check',
    scan_image_description: 'Scan a check for continue...',
    image_not_scanned: 'Image not scanned',
    front_image_not_scanned: 'Front image not scanned',
    back_image_not_scanned: 'Back image not scanned',
    check_front_image: 'Check front image',
    check_back_image: 'Check back image',
    recognize_images: 'Recognize images',
    check_maker_name: 'Maker name',
    check_maker_address: 'Maker address',
    check_maker_city: 'Maker city',
    check_maker_state: 'Maker state',
    check_maker_zip: 'Maker zip',
    check_amount: 'Check amount',
    check_raw_micr: 'Check raw micr',
    check_payee_name: 'Payee name',
    cash_a_check: 'Cash a check',
    fee: 'Fee',
    customer_amount: 'Dispense to customer'
  },
  check_cashing_validation: {
    customer_id_required: 'Customer ID is required',
    s_customer_id_required: 'Service customer ID is required',
    check_image_front_incorrect: 'Incorrect front image url',
    check_image_back_incorrect: 'Incorrect back image url',
    check_image_front_required: 'Front image is required',
    check_image_back_required: 'Back image is required',
    check_date_incorrect: 'Incorrect date',
    min_amount: 'Min. amount - {{amount}}',
    max_amount: 'Max. amount - {{amount}}',
    updating_amounts: 'Updating amounts...'
  },
  check_cashing_statuses: {
    unexpected: 'Unexpected transaction status',
    approved: 'Transaction has been approved',
    review: 'Transaction has been moved on review',
    bad_images: 'Data from Check not recognized fully. You can fill data manually or scan again',
    bad_maker: 'Bad maker. We can\'t accept check from this maker',
    canceled: 'Transaction has been canceled',
    internal: 'Internal error',
    not_parsed: 'We can\'t parse MICR',
    not_recognized: 'Data from Check not recognized fully. You can fill data manually or scan again'
  },
  check_cashing_review: {
    title: 'Transaction has been created successfully',
    cancel_transaction: 'Cancel transaction',
    approve_transaction: 'Approve transaction'
  },
  validation: {
    min: 'Field has to be longer than {{count}} characters!',
    max: 'Field has not to be longer than {{count}} characters!',
    required: 'Required field!',
    email: 'Field should be an email!',
    date: 'Field should be date!',
    invalid_phone: 'Invalid phone number',
    invalid_email: 'Invalid email address',
    duplicated_ssn: 'Customer with this SSN number already exist',
    duplicated_id: 'Customer with this ID info already exist',
  }
};

export default STRINGS;



// WEBPACK FOOTER //
// ./src/i18n/en_US.js